<agr-dialog (confirm)="save()" (alt)="nextDay()" (cancel)="cancel()" [data]="data">
  <div class="spacing--margin-horizontal spacing--margin-top">
    <div class="spacing--margin-bottom">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label">
            {{ 'wdo-registration.cycle-date' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="wdo-registration__cycledate">
            {{ data.cycle.cycleDate | agrDate }}
          </span>
        </div>
        <div class="flex--column spacing--margin-left field-width">
          <span class="text--small text--gray label">
            {{ 'wdo-registration.cycle-end-date' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ data.cycle.cycleEndDate | agrDate }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="spacing--margin-horizontal spacing--margin-top">
    <div class="spacing--margin-bottom">
      <div class="spacing--margin-top flex--row flex--wrap">
        <div class="flex--column spacing--margin-left field-width">
          <!-- weekselector -->
          <mat-label class="text--small text--gray">
            {{ 'wdo-registration.select-week' | translate }}
          </mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            data-test="wdo-registration__select-week"
            [(ngModel)]="selectedWeekNr"
            (ngModelChange)="setSelectedWeek(selectedWeekNr, selectedBarnId, $event)"
            [placeholder]="'wdo-registration.select-week-placeholder' | translate"
          >
            <mat-option *ngFor="let week of weeks" [value]="week.weekNr">
              {{ getWeekInfo(week) }}
            </mat-option>
          </mat-select>
        </div>
        <!-- dayselector -->
        <div
          *ngIf="!data.isDetailedView && this.getInputMethod() !== 'PerWeek'"
          class="flex--column spacing--margin-left field-width"
        >
          <mat-label class="text--small text--gray">
            {{ 'Days' | translate }}
          </mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            data-test="wdo-registration__select-barn"
            class="text--small"
            [(ngModel)]="selectedTabName"
            (ngModelChange)="setSelectedDay(selectedTabName)"
            [placeholder]="'Days' | translate"
          >
            <mat-option *ngFor="let tab of tabs; let i = index" [value]="tab.name">
              {{ tab?.name }}
            </mat-option>
          </mat-select>
        </div>
        <div class="flex--column spacing--margin-left field-width">
          <!-- barnselector -->
          <mat-label class="text--small text--gray">
            {{ 'wdo-registration.select-barn' | translate }}
          </mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            data-test="wdo-registration__select-barn"
            [(ngModel)]="selectedBarnId"
            (ngModelChange)="setSelectedFlock(selectedBarnId)"
            [placeholder]="'wdo-registration.select-barn-placeholder' | translate"
          >
            <mat-option *ngFor="let barn of barns" [value]="barn.id">
              {{ barn.name }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>

  <div class="flex--row" *ngIf="!!!allSettingsAreOff; else allSettingsAreOffMessage">
    <!-- Show when daily or dynamic values are defined. -->
    <mat-tab-group
      [mat-stretch-tabs]="false"
      *ngIf="this.getInputMethod() !== 'PerWeek'"
      data-test="wdo-registration__daytabs"
      animationDuration="0"
      color="accent"
      [ngClass]="
        data.isDetailedView ? 'weekRegistrationTabsDetailed' : 'weekRegistrationTabsSimple'
      "
      [(selectedIndex)]="selectedTabIndex"
      (selectedIndexChange)="updateAltButtonVisiblity()"
      preserveContent
    >
      <mat-tab
        *ngFor="let tab of tabs; let i = index"
        [label]="tab?.name"
        class="wdo-registration-tab"
      >
        <app-wdo-registration-form
          data-test="wdo-registration__dailyView"
          class="flex__child--auto"
          [formGroup]="formGroups[i]"
          [showFields]="tab.showFields"
          [feedIntakeSuffix]="tab.feedIntakeSuffix"
          [waterIntakeSuffix]="tab.waterIntakeSuffix"
          [feedIntakePlaceholder]="tab.feedIntakePlaceholder"
          [waterIntakePlaceholder]="tab.waterIntakePlaceholder"
          [chickAgeInDays]="tab.chickAgeInDays"
        >
        </app-wdo-registration-form>
      </mat-tab>
    </mat-tab-group>

    <!-- Show when only weekly data is defined. -->
    <app-wdo-registration-form
      data-test="wdo-registration__weeklyView"
      class="flex__child--auto"
      *ngIf="this.getInputMethod() === 'PerWeek'"
      [formGroup]="formGroups[0]"
      [showFields]="getShowFields()"
      [feedIntakeSuffix]="getFeedIntakeUnitLabels().suffix"
      [waterIntakeSuffix]="getWaterIntakeUnitLabels().suffix"
      [feedIntakePlaceholder]="getFeedIntakeUnitLabels().placeholder"
      [waterIntakePlaceholder]="getWaterIntakeUnitLabels().placeholder"
    >
    </app-wdo-registration-form>
  </div>
  <ng-template #allSettingsAreOffMessage>
    <div class="notification notification-warning">
      <mat-icon>warning</mat-icon>
      <b>{{ 'wdo-registration.all-settings-are-off-title' | translate }}</b>
      <div>{{ 'wdo-registration.all-settings-are-off-message' | translate }}</div>
    </div>
  </ng-template>
</agr-dialog>
